<div class="add-competency-form">
  <div class="row form-row">
    <div class="col-md-6">
      <div class="form-group">
        <label>Competency <span class="required-text">(required)</span></label>
        <p-dropdown
          class="form-control"
          [(ngModel)]="selectedCompetencyType"
          (ngModelChange)="onCompetencyTypeChange($event)"
          [options]="competencyTypeOptions"
          placeholder="Select competency..."
          [style]="{'width':'100%'}"
          filter="true">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="row form-row" *ngIf="showTurbineFields">
    <div class="col-md-4">
      <div class="form-group">
        <label>OEM</label>
        <p-dropdown
          class="form-control"
          [(ngModel)]="selectedManufacturer"
          (ngModelChange)="onManufacturerChange($event)"
          [options]="manufacturerOptions"
          placeholder="All"
          [style]="{'width':'100%'}">
        </p-dropdown>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Model</label>
        <p-multiSelect
          class="form-control"
          [(ngModel)]="selectedModels"
          (ngModelChange)="onModelsChange($event)"
          [options]="modelOptions"
          defaultLabel="All"
          [style]="{'width':'100%'}">
        </p-multiSelect>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Rating</label>
        <p-multiSelect
          class="form-control"
          [(ngModel)]="selectedRatings"
          [options]="ratingOptions"
          defaultLabel="All"
          [style]="{'width':'100%'}">
        </p-multiSelect>
      </div>
    </div>
  </div>

  <div class="row form-row" *ngIf="isPrivilegedFlow">
    <div class="col-md-12 d-flex align-items-center">
      <div class="my-site-toggle">
        <label class="my-site-toggle__switch">
          <input type="checkbox" [checked]="preApprovedSelected" (change)="onPreApprovedToggle()">
          <span class="my-site-toggle__slider"></span>
        </label>
        <span class="my-site-toggle__text">Pre-Approved</span>
      </div>
    </div>
    <div class="col-md-12" *ngIf="isForcedRequestEvidenceFlow">
      <small class="form-text text-muted">{{ forcedRequestEvidenceHelperText }}</small>
    </div>
  </div>

  <div class="row form-row" *ngIf="!isPrivilegedFlow">
    <div class="col-md-12">
      <div class="form-group">
        <label>Action</label>
        <div class="limited-action-group">
          <div class="limited-action-option">
            <p-radioButton
              inputId="limitedActionRequest"
              name="limitedAction"
              value="request"
              [(ngModel)]="limitedAction"
              (ngModelChange)="onLimitedActionChange($event)">
            </p-radioButton>
            <label class="limited-action-option__label" for="limitedActionRequest">Request Document from Worker</label>
          </div>

          <div class="limited-action-option">
            <p-radioButton
              inputId="limitedActionSubmit"
              name="limitedAction"
              value="submit"
              [(ngModel)]="limitedAction"
              (ngModelChange)="onLimitedActionChange($event)">
            </p-radioButton>
            <label class="limited-action-option__label" for="limitedActionSubmit">Submit Document for Approval</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row form-row" *ngIf="showRequestEvidenceToggle">
    <div class="col-md-12 d-flex align-items-center">
      <div class="my-site-toggle">
        <label class="my-site-toggle__switch">
          <input
            type="checkbox"
            [checked]="requestEvidence"
            (change)="onRequestEvidenceToggle()">
          <span class="my-site-toggle__slider"></span>
        </label>
        <span class="my-site-toggle__text">Request Evidence</span>
      </div>
    </div>
  </div>

  <div class="row form-row" *ngIf="showDocumentSection">
    <div class="col-md-6">
      <div class="form-group">
        <label>
          Supporting Document
          <span *ngIf="(isForcedRequestEvidenceFlow && preApprovedSelected) || submitForApprovalSelected" class="required-text">(required)</span>
        </label>
        <div class="doc-control">
          <div class="doc-upload" (click)="docInput.click()">
            <span class="doc-placeholder" *ngIf="!selectedDocument">Upload supporting document...</span>
            <span class="doc-placeholder" *ngIf="selectedDocument">{{ selectedDocument.name }}</span>
            <i class="pi pi-upload"></i>
          </div>
          <input
            #docInput
            type="file"
            class="doc-file-input"
            (change)="onFileSelected($event)"
            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .odt, .xls, .xlsx"
          />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Expires <span class="required-text">(required)</span></label>
        <p-calendar
          class="form-control"
          [(ngModel)]="expiryDate"
          [minDate]="today"
          dateFormat="dd/mm/yy"
          placeholder="Select expiry date..."
          [yearNavigator]="true"
          [yearRange]="datepickerYearRange"
          [monthNavigator]="true"
          [showIcon]="true"
          appendTo="body"
          panelStyleClass="add-competency-expiry-popup"
          [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%'}">
        </p-calendar>
        <small class="text-danger" *ngIf="isExpiryDateInPast">Please choose a future date.</small>
      </div>
    </div>
  </div>

  <div class="row form-row">
    <div class="col-md-12 d-flex align-items-center" *ngIf="showApplyToAllOption">
      <p-checkbox
        [(ngModel)]="applyToAll"
        [ngModelOptions]="{standalone: true}"
        binary="true"
        label="Apply to all users in list">
      </p-checkbox>
    </div>
    <div class="col-md-12 d-flex align-items-end">
      <button
        type="button"
        class="btn btn-round btn-success add-competency-btn"
        (click)="addCompetency()"
        [disabled]="isAddDisabled">
        {{ submitButtonLabel }}
      </button>
    </div>
  </div>
</div>
